// extracted by mini-css-extract-plugin
module.exports = {"container":"Byline_container__HeEAk","image_container":"Byline_image_container___QCFy","image_wrapper":"Byline_image_wrapper__QtZ_0","text":"Byline_text__ppgWc"};